const en_US = {
  '云服务系统': 'Cloud Service System',
  '租赁': 'Lease',
  '采购': 'Purchase',
  '自有': 'Own',
  '购物车': 'Shopping Cart',
  '原登录密码': 'Original Login Password',
  '新的登录密码': 'New Login Password',
  '确认新的登录密码': 'Confirm New Login Password',
  '网站首页': 'Website Homepage',
  '商品列表': 'Product List',
  '商品详情': 'Product Details',
  '请输入产品名称、货号': 'Please input product name and item number',
  '型 号': 'Model',
  '型号': 'Model',
  '规 格': 'Specification',
  '规格': 'Specification',
  '我要租': 'I want to lease',
  '我要买': 'I want to buy',
  '设备推荐': 'Recommended Equipment',
  '产品详情': 'Product Details',
  '姓名': 'Name',
  '职务': 'Position',
  '单位': 'Unit',
  '手机号码': 'Mobile No.',
  '电子邮箱': 'E-mail',
  '我的报价单': 'My Quotation',
  '提交订单': 'Submit Order',
  '合并报价单': 'Combine Quotation',
  '报价单编号': 'Quotation No.',
  '报价单总金额': 'Quotation Total Amount',
  '下载报价单': 'Download Quotation',
  '下单': 'Place Order',
  '转为租赁订单': 'Change to Lease Order',
  'PO编号': 'PO No.',
  '请输入编号': 'Input No.',
  '选择发票': 'Choose Invoice',
  '发票抬头': 'Invoice Title',
  '默认发票': 'Default Invoice',
  '纳税登记号': 'Tax Registration No.',
  '请选择相同类型的产品进行合并': 'Please choose products of the same type to combine',
  '我的求购单': 'My Purchase Request',
  '提交求购单': 'Submit Purchase Request',
  '求购清单': 'Purchase Request List',
  '订购后在货期内发货，若因特殊原因货期状态发生变化，客服人员会第一时间与您确认货期。': 'After placing the order, the shipment will be made within certain period. If the period changes due to special reasons, the customer service staff will confirm the delivery date with you as soon as possible.',
  '全选': 'Select All',
  '产品品名': 'Product Name',
  '品牌': 'Brand',
  '货号': 'Item No.',
  '产品说明': 'Product Description ',
  '数量': 'No.',
  '数 量': 'No.',
  '项目编号': 'Project No.',
  '需要计量': 'Measurement Required',
  '租': 'Lease',
  '购': 'Purchase',
  '如您需要的商品不在商城中，可填写以下信息：请尽可能填写详细，以便我们更好的为您提供服务。': 'If the product you need is not in the mall, you can fill in the following information: please provide information as detailed as possible, so that we can serve you better.',
  '编辑': 'Edit',
  '添加新求购': 'Add New Purchase Request',
  '提交求购单后，我们会在2个小时内联系您': 'We will contact you within 2 hours after you submit the purchase order',
  '清空求购单': 'Empty Purchase Request',
  '用户中心': 'User Centre',
  '在线求购': 'Online Purchase',
  '我的求购记录': 'My Purchase Request History',
  '个人中心主页': 'Personal Centre Homepage',
  '交易记录': 'Transaction History',
  '我的订单': 'My Order',
  '我的管理': 'My Management',
  '项目管理': 'Project Management',
  '设备管理': 'Equipment Management',
  '服务提醒': 'Service Reminder',
  '系统设置': 'System Configuration',
  '完善个人信息': 'Complete Personal Information',
  '求购记录': 'Purchase Request History',
  '全部求购单': 'All Purchase Requests',
  '待报价': 'To Quote',
  '已报价': 'Quoted',
  '已关闭': 'Closed',
  '商品名': 'Product Name',
  '求购编号': 'Purchase Request No.',
  '求购时间': 'Purchase Time',
  '单价': 'Unit Price',
  '租期': 'Lease Period',
  '合计': 'Total',
  '预计到货': 'Expected Delivery',
  '状态': 'Status',
  '注销退出': 'Logout and Exit',
  '修改密码': 'Change Password',
  '收货地址': 'Shipping Address',
  '发票信息': 'Invoice Information',
  '产品缺货': 'Out of Stock',
  '总计': 'A total of',
  '个记录': 'records',
  '订单类型': 'Order Type',
  '全部': 'All',
  '购买': 'Purchase',
  '待通知发货': 'Shipped to be Notified',
  '通知发货': 'Shipment Notified',
  '订单编号': 'Order No.',
  'PO号': 'PO number',
  '报价时间': 'Quotation Time',
  '已通知': 'Notified',
  '查看物流': 'Check Logistics',
  '部分已通知': 'Partially Notified',
  '设为默认地址': 'Set as Default Address',
  '新增收货地址':'Add Shipping Address',
  '编辑收货地址':'Edit Shipping Address',
  '配送地址':'Shipping Address',
  '收货人姓名': 'Shipped to',
  '邮政编码': 'Postal No.',
  '省': 'Province',
  '区': 'District',
  '手机': 'Mobile',
  '备注': 'Note',
  '市': 'City',
  '地址': 'Address',
  '详细地址': 'Detailed Address',
  '默认地址': 'Default Address',
  '提醒事项': 'Reminder',
  '关联信息': 'Associated Information',
  '提醒时间': 'Reminder Time',
  '关联邮箱': 'Associated E-mail',
  '租赁报价单编号': 'Lease Quotation No.',
  '供方': 'Supplier',
  '联系人': 'Contact',
  '电话': 'Phone',
  '需方': 'Buyer',
  '序号': 'No.',
  '产品名称': 'Product Name',
  '增值税率': 'VAT Rate',
  '月': 'month',
  '总价': 'Total Price',
  '序列号': 'Serial No.',
  '所属项目': 'Project ',
  '联系我们': 'Contact Us',
  '服务热线': 'Service Hotline',
  '地址：上海市浦东新区达尔文路88号1号楼1层': 'Add: Floor 1, No.1 Building, No. 88 Daerwen Road, Pudong New District, Shanghai ',
  '泉心泉意 版权所有': 'Copyright Reserved by Lab Direct ',
  '项目名称': 'Project Name',
  '项目组': 'Project Group',
  '负责人': 'Person in Charge',
  '联系方式': 'Contact',
  '邮箱': 'E-mail',
  '设备数量': 'No. of Equipment ',
  '操作': 'Operation ',
  '再增加一条': 'Add 1 More Item',
  '首页': 'Homepage',
  '业务介绍':'Our Business',
  '服务优势':'Service Advantages',
  '服务范围':'Coverage Of Services',
  '常见问题':'FAQ',
  '回顶部':'Top',
  '我需要':'I need',
  '台':'',
  '确认':'Confirm',
  '取消':'Cancel',
  '温馨提示':'Warm prompt',
  '确定要注销退出吗？':'Are you sure you want to log off',
  '已完成':'Finished',
  '搜索':'Search',
  '请输入':'Please Enter',
  '订单状态':'Status',
  '选择货物和送货地址':'Check Order',
  '管理收货地址':'Management Address',
  '收货信息':'Address',
  '不超过200字，非必填':'No more than 200 words, not required',
  '确认提交':'Confirm',
  '返回修改':'Return for correction',
  '删除':'Delete',
  '保存':'Save',
  '请填写内容':'Please fill in',
  '沪ICP备17045478号':'Shanghai ICP No. 17045478',
  '请登录您的账号':'Please Sing in',
  '忘记密码':'Forget the password',
  '自动登录':'Record the password',
  '如果您没有平台账号':'If you don\'t have a platform account',
  '立即注册':'Sign Up',
  '请输入密码':'Please enter your password',
  '手机号/邮箱':'Please enter your account',
  '请输入用户名':'Please enter your account',
  '用户名或密码错误':'User name or password error',
  '登录':'Sign in',
  '注册':'Sign up',
  '如果您已有平台账号':'If you already have a platform account',
  '立即登录':'Sign in',
  '隐私保护政策':'Privacy Protection Policy',
  '会员注册协议':'Member Registration Agreement',
  '和':'And',
  '同意协议并注册':'Agree to the agreement and register',
  '设置密码':'Set a password',
  '确认密码':'Confirm password',
  '公司名称':'Company name',
  '欢迎加入Lab Direct平台':'Welcome to the Lab Direct Platform',
  '请输入电子邮箱':'Please enter email address',
  '输入的电子邮箱格式有误':'Incorrect format of email address',
  '此电子邮箱账号即为登录名':'This email account is the login name',
  '请输入您的手机号':'Please enter your mobile phone number',
  '请输入正确的手机号码':'Please enter the correct mobile phone number',
  '请输入您的姓名':'Please enter your name',
  '姓名为2-10个非空字符':'Names are 2-10 non-null characters',
  '请输入6-10位由数字字母组成的密码':'Please enter a 6-10 - digit alphanumeric password!',
  '请再次输入密码':'Please enter your password again!',
  '两次输入的密码不匹配':'The two passwords don\'t match!',
  '请输入公司名称':'Please enter company name',
  '填写并核对订单信息':'Fill in and check the order information',
  '订购后在货期内发货，如果因特殊原因货期状态发生变化，客服人员会第一时间与您确认货期':'After ordering the goods within the delivery period, if the delivery status changes due to special reasons, customer service staff will be the first time to confirm the delivery date with you',
  '商品确认':'Confirm the goods',
  '请选择发票信息，核对订单信息':'Please choose the invoice information, and check order information',
  '订单总金额 共计':'Total amount of the order   Sum to',
  '恭喜！您的订单已提交！':'Congratulations! Your order has been submitted!',
  '您的订单号为：':'Your order number is',
  '您的订单已经收到，请注意查收您的邮箱。':'Your order has been received, please pay attention to check your email.',
  '我们将立即处理您的订单以锁定国内现货。':'We will process your order immediately to lock in domestic stock.',
  '返回我的报价单':'Return my quotation',
  '返回首页':'Return to the home page',
  '返回我的订单':'Return my order',
  '返回订单列表':'Return to the order list',
  '配送下单时间':'Delivery ordering time',
  '运单号码':'Waybill Number',
  '物流公司':'Logistics Company',
  '物流信息':'Logistics Information',
  '剩余':'The remaining',
  '台未发':'sets have not been delivered',
  '投放地点':'Place to launch',
  '设备属性':'Device Properties',
  '计量':'Measurement',
  '维修':'Repair',
  '查看计量证书':'Check the certificate for measurement',
  '开票类型':'Fapiao Type',
  '增值税专用发票':'VAT special invoice',
  '开户银行':'Bank of Deposit',
  '银行账号':'Bank Account',
  '开票通讯地址':'Mailing Address of Fapiao',
  '开票联系电话':'Contact Number',
  '是':'Yes',
  '否':'No',
  '物流单号':'Tracking Number',
  '待发货':'Wait For Sending',
  '中心号':'Center No.',
  '重置':'Reset',
  '展开':'Unfold',
  '收起':'Fold',
  '请选择':'Please Choose',
  // '':'',
  // '':'',
  // '':'',
}

export default en_US
